import {
  GetUserProfileResponse,
  getUserProfile,
} from '@otter-ai/recall-client';
import { HOUR_MS } from '#constants';
import { AdditionalQueryOptions, userState } from '#utils';

type UserProfileQueryKey = ['user/profile'];

const staleTime = 2 * HOUR_MS; // Data stays fresh for 2 hours

type AdditionalUserProfileQueryOptions = AdditionalQueryOptions<
  GetUserProfileResponse,
  UserProfileQueryKey
>;

export type UserProfileQuery = {
  readonly queryKey: UserProfileQueryKey;
  readonly queryFn: () => Promise<GetUserProfileResponse>;
} & AdditionalUserProfileQueryOptions;

/**
 * Create a query to fetch the user's profile
 *
 * @example
 * ```tsx
 * const { data: userProfile } = useQuery(userProfileQueryCreator());
 * ```
 */

export function userProfileQueryCreator(
  additionalOptions: AdditionalUserProfileQueryOptions = {},
): UserProfileQuery {
  return {
    ...additionalOptions,
    staleTime,
    queryKey: ['user/profile'],
    queryFn: async () => {
      const response = await getUserProfile({ throwOnError: true });
      const userData = response.data;
      if (userData?.user?.id) {
        userState.userid = userData.user.id.toString();
      }

      return userData;
    },
  };
}
